import { LocalStorageService } from '../../services/localStorageService';
import {
  SET_SELECTED_DEPARTMENT,
  UserActionTypes,
  UserState,
  GET_USER_INFO,
  SET_USERNAME,
  Department,
} from './types';

import { Relation, RoleEnumDto } from '../../.generated/admin-api';
import { CLEAR_USER_CACHE } from '../types';

function filterRegistratorDepartments(
  departments?: Department[],
  departmentRelations?: Relation[],
): Department[] | undefined {
  if (!departments || !departmentRelations) {
    return undefined;
  }

  const relationMap: Record<string, Relation> = {};
  for (const rel of departmentRelations) {
    if (rel.roles.some((role) => role === RoleEnumDto.REGISTRATOR)) {
      relationMap[rel.id] = rel;
    }
  }

  return departments.filter((dep) => !!relationMap[dep.id]);
}

export function userReducer(
  state: UserState | undefined,
  action: UserActionTypes,
): UserState {
  if (state === undefined) {
    const username = LocalStorageService.getUsername() ?? undefined;
    return {
      username,
    };
  }

  switch (action.type) {
    case SET_USERNAME:
      return {
        ...state,
        username: action.username,
      };
    case GET_USER_INFO:
      return {
        ...state,
        organizationRelations: action.organizationRelations,
        departmentRelations: action.departmentRelations,
        departments: filterRegistratorDepartments(
          action.departments,
          action.departmentRelations,
        ),
      };
    case SET_SELECTED_DEPARTMENT: {
      return {
        ...state,
        selectedDepartment: action.department,
      };
    }
    case CLEAR_USER_CACHE:
      return {};
    default:
      return state;
  }
}
